import React from 'react';
import 'leaflet/dist/leaflet.css';
import {BrowserRouter as Router, Route, Routes,} from 'react-router-dom';
import LandingPage from "./components/landing/LandingPage";
import MapRouteGuard from "./components/map/MapRouteGuard";
import Login from "./components/authentication/Login";
import Register from "./components/authentication/Register";
import AddCenterForm from "./components/surveys/AddCenterForm";
import AddDiseaseForm from "./components/surveys/AddDiseaseForm";
import AddOrganizationForm from "./components/surveys/AddOrganizationForm";
import RareDiseases from "./components/pages/RareDiseases";
import AboutMap from "./components/pages/AboutMap";
import ESAE from "./components/pages/ESAE";
import Information from "./components/pages/Information";
import FAQ from "./components/pages/FAQ";
import More from "./components/pages/More";

function App() {
    return (<Router>
        <div className="App">
            <Routes>
                <Route path="/" element={<LandingPage/>}/>
                <Route path="/map" element={<MapRouteGuard/>}/>
                <Route path="/login" element={<Login/>}/>
                <Route path="/register" element={<Register/>}/>
                <Route path="/forms/addCenterForm" element={<AddCenterForm/>}/>
                <Route path="/forms/addDiseaseForm" element={<AddDiseaseForm/>}/>
                <Route path="/forms/addOrganizationForm" element={<AddOrganizationForm/>}/>
                <Route path="/rare-diseases" element={<RareDiseases/>}/>
                <Route path="/about-map" element={<AboutMap/>}/>
                <Route path="/about-us" element={<ESAE/>}/>
                <Route path="/information" element={<Information/>}/>
                <Route path="/faq" element={<FAQ/>}/>
                <Route path="/more" element={<More/>}/>
            </Routes>
        </div>
    </Router>);
}

export default App;